import React, { Component } from "react";
import { Image, TouchableOpacity, View, TouchableWithoutFeedback } from "react-native";
import TextView from "./TextView";
import { icons } from "../theme/icons";
import { componentStyles, appStyles } from "../theme/styles";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';
import { showPrompt } from "../utils/utils";
import CedarMaps from '@cedarstudios/react-cedarmaps';
import { wp, hp } from "../utils/responsive";

export default class FavortiAddressItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        }
    }

    render() {
        var item = this.props.data;
        return (
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={componentStyles.favoritAddressWraper}>
                <View style={appStyles.rowBetween}>
                    <TouchableOpacity onPress={() => {
                        this.props.onRemove();
                    }}>
                        <Image source={icons['more']} style={componentStyles.smallIconWhite} />
                    </TouchableOpacity>
                    <View style={appStyles.row}>

                        <TextView style={{ color: 'white' }}>{item.nameaddress}</TextView>
                        <Image source={icons['pinmap']} style={componentStyles.smallIconWhite} />
                    </View>

                </View>
                <View style={componentStyles.mapFavoritWraper}>

                    <CedarMaps
                        logoPosition='top-left'
                        containerStyle={{
                            height: '100vh',
                            width: '100%'
                        }}
                        onMoveEnd={(_, event) => {
                            console.log(event)
                            if (event.target?._easeOptions?.center != null) {
                                if (Array.isArray(event.target._easeOptions.center)) {
                                    this.setCenterMap(event.target._easeOptions.center)
                                } else {
                                    this.setCenterMap([event.target._easeOptions.center.lng, event.target._easeOptions.center.lat])
                                }
                            } else if (event.lngLat != null) {
                                this.setCenterMap([event.lngLat.lng, event.lngLat.lat])
                            }
                        }}
                        token='de1f4bf85b1e70f435a36cc27a5a61075793a194'
                        center={[item.lng, item.lat]}
                    >
                    </CedarMaps>
                </View>

            </LinearGradient>
        );
    }
}


